import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// import handleNavigation from '../../utils/paymentNavigation';
import QuestionaireComponent from "./../../components/questionaire/index";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { getProfileApi } from "../../services/profile.service";
import PageLoader from "../../components/common/loader/pageLoader";
import ScrollToTop from "../../utils/scrollToTop";
import { Helmet } from "react-helmet";
import { getReviseRoutineApi } from "../../services/reviseRoutine.service";
import { message } from "antd";

interface props {}

const Questsionaire: React.FC<props> = () => {
  const token = localStorage.getItem("alrounderToken");
  // const isAuthenticated = token ? true : false;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const state = useAppSelector((state) => state);
  const { userData: redUserData }: { userData?: any } = state.profile;
  const [surveyId, setSurveyId] = useState();
  const [userData, setUserData] = useState(redUserData);

  useEffect(() => {
    if (token) {
      setLoading(true);
      fetchProfile();
    }
  }, [token]);

  const fetchProfile = () => {
    dispatch(
      getProfileApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data?: any) => {
          setUserData({ user_information: data });
          setSurveyId(data?.active_survey_id);
          // if (!data?.can_revise && data?.has_store) {
          //   navigate("/store");
          // }
          // navigate(handleNavigation(data?.survey_status, data?.has_store))
        },
        unauthenticatedCallback: () => {},
      })
    );

    dispatch(
      getReviseRoutineApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data: any) => {
          const routineStatus = data?.routine_status;
          if (routineStatus !== "unlocked") {
            message.warning(
              "You cannot access this page as your routine is locked."
            );
            navigate("/store/revise-routine");
          }
        },
        unAunthenticatedCallback: () => {},
      })
    );
  };

  if (loading) {
    return <PageLoader />;
  }

  return (
    <>
      <Helmet>
        <title>Skincare Steps Build Instantly</title>
        <meta
          name="description"
          content="We build your skincare steps instantly based on the skincare products you are currently using. Try our award winning skincare routine builder for free."
        />
      </Helmet>
      <ScrollToTop />
      <QuestionaireComponent surveyId={surveyId} userData={userData} />
    </>
  );
};

export default Questsionaire;
